import { render, staticRenderFns } from "./complianceDialog.vue?vue&type=template&id=98cfb936&scoped=true"
import script from "./complianceDialog.vue?vue&type=script&lang=js"
export * from "./complianceDialog.vue?vue&type=script&lang=js"
import style0 from "./complianceDialog.vue?vue&type=style&index=0&id=98cfb936&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98cfb936",
  null
  
)

export default component.exports